import React from 'react';
import PropTypes from 'prop-types';
import PhoneLink from 'workOrderComponents/PhoneLink';
import IconMenu from 'material-ui/IconMenu';
import FlatButton from 'material-ui/FlatButton';
import TextFormatter from 'utils/TextFormatter';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import OrderDetailLoading from 'workOrderComponents/OrderDetailLoading';

const PhoneMenu = (props) => {

    const {accountCustomerInfo, customerInfo, loading} = props;

    if (loading) {
        return (<OrderDetailLoading message="loading..." isLoading={loading}/>);
    }
    if (!accountCustomerInfo) {
        return null;
    }

    let name = '';

    const companyName = customerInfo.get('companyName');

    if (customerInfo) {
        if(companyName && companyName.length > 0){
            name = TextFormatter.titleCase(' ', companyName);
        }
        else
        {
            name = TextFormatter.titleCase(' ', customerInfo.get('firstName'), customerInfo.get('lastName'));
        }
    }

    const button = (<FlatButton
        style={{
        width: '100%'
    }}
        labelStyle={{
        textDecoration: 'underline',
        paddingLeft: '0',
        textOverflow: 'ellipsis',
        paddingRight: '0'
    }}
        label={name}/>);

    const dayPhone = (<PhoneLink
        accountCustomerInfo={accountCustomerInfo}
        phoneKey="daytimePhoneNumber"
        key="daytimePhoneNumber"
        label="Daytime Phone"/>);

    const eveningPhone = (<PhoneLink
        key="eveningPhoneNumber"
        phoneKey="eveningPhoneNumber"
        accountCustomerInfo={accountCustomerInfo}
        label="Evening Phone"/>);

    const otherPhone = (<PhoneLink
        phoneKey="otherPhoneNumber"
        key="otherPhoneNumber"
        accountCustomerInfo={accountCustomerInfo}
        label="Other Phone"/>);

    const menuItems = [];
    menuItems.push((<MenuItem
        key="name"
        primaryText={(
        <div
            style={{
            width: '100%',
            height: '38px',
            display: 'inline-block',
            wordWrap: 'break-word',
            wordBreak: 'break-all',
            whiteSpace: 'normal'
        }}>{name}</div>
    )}
        value={name}/>));
    menuItems.push((<Divider key="divider"/>));
    menuItems.push(dayPhone);
    menuItems.push(eveningPhone);
    menuItems.push(otherPhone);

    return (
        <IconMenu iconButtonElement={button}>
            {menuItems}

        </IconMenu>
    );

};

PhoneMenu.propTypes = {
    accountCustomerInfo: PropTypes.object,
    customerInfo: PropTypes.object,
    loading: PropTypes.bool
};

export default PhoneMenu;



// WEBPACK FOOTER //
// ./src/components/work-order/PhoneMenu.js